export default "__VITE_ASSET__3f6967de__"